import * as React from 'react';
import { IChannel } from '../../../../data/api/models';
import { Col, Row } from 'react-bootstrap';

interface IFooterProps {
  channel: IChannel;
}

export default class Footer extends React.Component<IFooterProps, any> {
  public render() {
    return (
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="container" />
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Footer/index.tsx